module.exports = __webpack_public_path__ + "static/img/iview.2ff4d7f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/iview.png
// module id = XyQS
// module chunks = 0